<template>
  <Dialog as="div" class="relative z-10" :open="true">
    <div class="fixed inset-0"/>

    <div class="fixed inset-0 overflow-hidden">
      <div class="absolute inset-0 overflow-hidden">
        <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
          <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                           enter-from="translate-x-full" enter-to="translate-x-0"
                           leave="transform transition ease-in-out duration-500 sm:duration-700"
                           leave-from="translate-x-0" leave-to="translate-x-full">
            <DialogPanel class="pointer-events-auto w-screen max-w-md">
              <form class="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl" @submit.prevent="postNow">
                <div class="h-0 flex-1 overflow-y-auto">
                  <div class="bg-indigo-700 px-4 py-6 sm:px-6">
                    <div class="flex items-center justify-between">
                      <DialogTitle class="text-base font-semibold leading-6 text-white">Nouvelle transaction
                      </DialogTitle>
                    </div>
                    <div class="mt-1">
                      <p class="text-sm text-indigo-300">Get started by filling in the information below to create your
                        new project.</p>
                    </div>
                  </div>
                  <div class="flex flex-1 flex-col justify-between">
                    <div class="divide-y divide-gray-200 px-4 sm:px-6">
                      <div class="space-y-6 pb-5 pt-6">
                        <div>
                          <label for="project-name" class="block text-sm font-medium leading-6 text-gray-900">Fournisseur</label>
                          <div class="mt-1">
                            <input type="text" name="from_name" id="from_name" v-model="transactionData.from_name"
                                   class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                          </div>
                        </div>
                        <div>
                          <label for="bank_id"
                                 class="block text-sm font-medium leading-6 text-gray-900">Banque</label>
                          <div class="mt-1">
                            <Multiselect v-if="bankData.length"
                                         v-model="transactionData.bank_id"
                                         id="bank_id"
                                         :options="bankData"
                                         label="name"
                                         valueProp="id"
                                         :object="false"
                                         :min-chars="1"
                            />
                          </div>
                        </div>
                        <div>
                          <label for="description"
                                 class="block text-sm font-medium leading-6 text-gray-900">Description</label>
                          <div class="mt-1">
                            <input type="text" name="description" id="description" v-model="transactionData.description"
                                   class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                          </div>
                        </div>
                        <div>
                          <label for="amount" class="block text-sm font-medium leading-6 text-gray-900">Montant en
                            EUR</label>
                          <div class="mt-1">
                            <input type="text" name="amount" id="amount" v-model="transactionData.amount"
                                   class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                          </div>
                        </div>
                        <div>
                          <label for="local_amount" class="block text-sm font-medium leading-6 text-gray-900">Montant en
                            devise</label>
                          <div class="mt-1">
                            <input type="text" name="local_amount" id="local_amount"
                                   v-model="transactionData.local_amount"
                                   class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                          </div>
                        </div>
                        <div>
                          <label for="local_currency"
                                 class="block text-sm font-medium leading-6 text-gray-900">Devise</label>
                          <div class="mt-1">
                            <input type="text" name="local_currency" id="local_currency"
                                   v-model="transactionData.local_currency"
                                   class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                          </div>
                        </div>

                        <div>
                          <label for="date"
                                 class="block text-sm font-medium leading-6 text-gray-900">Date</label>
                          <div class="mt-1">
                            <input type="text" name="date" id="date" v-model="transactionData.date"
                                   class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex flex-shrink-0 justify-end px-4 py-4">
                  <button type="button"
                          class="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                    Annuler
                  </button>
                  <button type="button"
                          @click="postNow"
                          class="ml-4 inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                    Sauvegarder
                  </button>
                </div>
              </form>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import Multiselect from '@vueform/multiselect'
</script>


<script>
import moment from 'moment'
import axios from "axios";
import {useFetch, usePost, usePostFile} from "@/composables/fetch";
import router from "@/router";
import {v4 as uuidv4} from 'uuid';

export default {
  props: {},
  data: () => ({
    bankData: [],
    endpoint: 'transaction',
    transactionData: {
      id: uuidv4(),
      from_name: '',
      bank_id: '1',
      description: '',
      amount: '',
      local_amount: '',
      local_currency: 'EUR',
      date: moment().format('YYYY-MM-DD'),
      has_invoice: 1
    },
  }),
  mounted() {
    this.fetchBankData()
  },
  methods: {
    async postNow() {
      const token = await this.$auth.getAccessTokenSilently();
      const data = await usePost(this.endpoint, this.transactionData, token)
      console.log("[transactionAdd]", data)
      if (data.data[0].id) {
        console.log("[transactionAdd]", data.data[0].id)
        router.push({ path: '/transaction/' + data.data[0].id })
      }
    },
    async fetchBankData() {

      const token = await this.$auth.getAccessTokenSilently();
      const HTTP = axios.create({
        baseURL: `https://billing.clafoutis.eu/api`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      this.bankData = []
      HTTP.get('/bank')
          .then(response => {
            console.log(response.data)
            this.bankData = response.data
            this.isLoaded = true;
          })
          .catch(e => {
            console.log(e)
          })
    },
  }
}
</script>
